import 'fomantic-ui-less/definitions/globals/reset.less';
import 'fomantic-ui-less/definitions/globals/site.less';

import 'fomantic-ui-less/definitions/elements/button.less';
import 'fomantic-ui-less/definitions/elements/container.less';
import 'fomantic-ui-less/definitions/elements/divider.less';
import 'fomantic-ui-less/definitions/elements/header.less';
import 'fomantic-ui-less/definitions/elements/icon.less';
import 'fomantic-ui-less/definitions/elements/image.less';
import 'fomantic-ui-less/definitions/elements/input.less';
import 'fomantic-ui-less/definitions/elements/label.less';
import 'fomantic-ui-less/definitions/elements/list.less';
import 'fomantic-ui-less/definitions/elements/segment.less';
import 'fomantic-ui-less/definitions/elements/text.less';

import 'fomantic-ui-less/definitions/collections/breadcrumb.less';
import 'fomantic-ui-less/definitions/collections/form.less';
import 'fomantic-ui-less/definitions/collections/grid.less';
import 'fomantic-ui-less/definitions/collections/menu.less';
import 'fomantic-ui-less/definitions/collections/message.less';
import 'fomantic-ui-less/definitions/collections/table.less';

import 'fomantic-ui-less/definitions/views/card.less';
import 'fomantic-ui-less/definitions/views/item.less';

import 'fomantic-ui-less/definitions/modules/transition.less';
import 'fomantic-ui-less/definitions/modules/dropdown.less';

import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';

import '@github/relative-time-element';

import '../../images/close-circle-outline-red.svg';
import '../../images/oauth2-azure.svg';
import '../../images/oauth2-google.svg';
import '../../images/simworkflow-logo.svg';
import '@mdi/svg/svg/chevron-double-left.svg';
import '@mdi/svg/svg/chevron-down.svg';
import '@mdi/svg/svg/chevron-left.svg';
import '@mdi/svg/svg/chevron-right.svg';
import '@mdi/svg/svg/cog-transfer-outline.svg';

$(document).ready(() => {
    $(document.querySelectorAll('.ui.dropdown')).dropdown({
        duration: 0
    });
    $(document.getElementById('page-header-dropdown')).dropdown({
        action: 'nothing',
        selectOnKeydown: false,
        duration: 0
    });
    $(document.querySelectorAll('div.message .close')).on('click', function () {
        $(this).closest('.ui.message').transition('fade');
    });
});
